/*
 * Valenor — Promo deadline countdown.
 * Reads data-vln-promo-end="YYYY-MM-DD" on each promo banner and fills the
 * [data-vln-promo-deadline] slot with "Fin dans N jour[s]". Template is
 * configurable via data-vln-promo-label (uses {days} and {s}).
 * Hides the whole banner once expired (opt-in with
 * data-vln-promo-hidden-when-expired).
 */
(() => {
  if (typeof window === 'undefined' || window.__vlnPromoInit) return;
  window.__vlnPromoInit = true;

  const applyLabel = (template, days) =>
    template.replace('{days}', days).replace('{s}', days > 1 ? 's' : '');

  const init = () => {
    const now = Date.now();
    document.querySelectorAll('[data-vln-promo-end]').forEach((el) => {
      const endStr = el.dataset.vlnPromoEnd;
      const label = el.dataset.vlnPromoLabel || 'Fin dans {days} jour{s}';
      const end = new Date(endStr + 'T23:59:59');
      if (isNaN(end.getTime())) return;
      const daysLeft = Math.ceil((end.getTime() - now) / (1000 * 60 * 60 * 24));
      const slot = el.querySelector('[data-vln-promo-deadline]');
      if (daysLeft <= 0) {
        if (el.dataset.vlnPromoHiddenWhenExpired === 'true') {
          el.style.display = 'none';
        } else if (slot) {
          slot.textContent = 'Offre terminée';
        }
        return;
      }
      if (slot) slot.textContent = applyLabel(label, daysLeft);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
